export function isIConditional(obj) {
    return obj && obj.discriminator === 'IConditional';
}
//# sourceMappingURL=IConditional.js.map